import { Component, Input } from '@angular/core';
import { BreezeService } from '../../services/breeze.service';
import { SearchParams } from '../../../core/models/breeze';
import { CommonModule } from '@angular/common';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-loading-trips-dialog',
    templateUrl: './loading-trips-dialog.component.html',
    styleUrls: ['./loading-trips-dialog.component.scss'],
    imports: [CommonModule, NgbProgressbar]
})
export class LoadingTripsDialogComponent {
  timer = 0;
  intervalInstance: any;
  @Input('title') public title: string | undefined;
  @Input('subtitle') public subtitle: string | undefined;
  searchParams: SearchParams | undefined;
  constructor(private breezeService: BreezeService) {}

  ngOnInit(): void {
    this.breezeService.getSearchParams().subscribe((searchParams) => {
      this.searchParams = searchParams;
    });
    this.intervalInstance = setInterval(() => {
      this.timer = this.timer > 10000 ? -5 : (this.timer += 1);
    }, 100);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalInstance);
  }
}
